<template>
  <section class="comment-section">
    <div class="comment-header">
      <div class="section-title-bar">
        <v-icon small color="#10b981" class="comment-title-icon">mdi-comment-text-multiple-outline</v-icon>
        <h3 class="comment-title">评论交流</h3>
        <span class="comment-badge" v-if="comments && comments.length">{{ comments.length }}</span>
      </div>

      <!-- 发表评论输入区域 -->
      <div class="input-card">
        <div class="user-avatar-glow" v-bgImg="`https://www.picsum.photos/128`"></div>
        <div class="content-box">
          <div class="message-box">
            <v-text-field
              class="comment-input"
              v-model="message"
              hide-details="auto"
              placeholder="分享你对该素材的想法..."
              dense
              outlined
              dark
              @focus="isShowOpeBtn = true"
              @keyup.enter="on_send_comment"
            />
            <div class="comment-actions" v-if="isShowOpeBtn">
              <v-btn
                text
                small
                class="btn-cancel"
                @click="on_cancel_comment"
              >
                取消
              </v-btn>
              <v-btn
                small
                class="btn-submit"
                :disabled="!message || !message.trim()"
                @click="on_send_comment"
              >
                <v-icon x-small class="mr-1">mdi-send</v-icon>
                发送
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 评论列表 -->
    <div class="comment-list" v-if="comments && comments.length > 0">
      <div class="comment-item-card" v-for="chat in comments" :key="chat.id">
        <div class="avatar-sm" v-bgImg="`https://www.picsum.photos/128`"></div>
        <div class="comment-body">
          <div class="comment-meta">
            <span class="author-name">热心用户</span>
            <time class="post-date">{{ formate_date(chat.created_at) }}</time>
          </div>
          <p class="comment-text">
            {{ chat.comment }}
          </p>
        </div>
      </div>
    </div>

    <!-- 暂无评论空状态 -->
    <div class="empty-comment" v-else>
      <v-icon color="rgba(255, 255, 255, 0.2)" size="28">mdi-message-outline</v-icon>
      <p class="empty-text">暂无评论，快来发表第一条见解吧~</p>
    </div>
  </section>
</template>

<script>
import { get_api_data } from "@/utils/ajax";
import { formatDistance, parseISO } from "date-fns";
import { zhCN } from "date-fns/locale";

export default {
  name: "comment",
  props: {
    comments: {
      type: Array,
      required: true,
      default: () => [],
    },
    fileId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isShowOpeBtn: false,
      message: "",
      isSending: false,
    };
  },
  methods: {
    on_cancel_comment() {
      this.isShowOpeBtn = false;
      this.message = "";
    },

    async on_send_comment() {
      if (!this.message || !this.message.trim() || this.isSending) return;
      this.isSending = true;
      try {
        await get_api_data("POST", "materials/comments", {
          commentable_id: this.fileId,
          message: this.message.trim(),
        });
        this.message = "";
        this.isShowOpeBtn = false;
        this.$emit("ccUpdateComment");
      } catch (err) {
        console.error("提交评论失败:", err);
      } finally {
        this.isSending = false;
      }
    },

    formate_date(createDate) {
      if (!createDate) return "";
      try {
        return formatDistance(parseISO(createDate), new Date(), {
          addSuffix: true,
          locale: zhCN,
        });
      } catch (e) {
        return createDate;
      }
    },
  },
};
</script>

<style lang="scss">
.comment-section {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);

  .section-title-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;

    .comment-title-icon {
      flex-shrink: 0;
    }

    .comment-title {
      font-size: 15px;
      font-weight: 700;
      color: rgba(255, 255, 255, 0.95);
      letter-spacing: 0.02em;
      margin: 0;
    }

    .comment-badge {
      margin-left: 8px;
      padding: 1px 7px;
      font-size: 11px;
      font-weight: 700;
      border-radius: 10px;
      background: rgba(16, 185, 129, 0.18);
      color: #34d399;
      border: 1px solid rgba(16, 185, 129, 0.3);
    }
  }

  .input-card {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    border-radius: 12px;
    background: rgba(15, 23, 42, 0.55);
    border: 1px solid rgba(255, 255, 255, 0.08);
    transition: all 0.25s ease;

    &:focus-within {
      border-color: rgba(16, 185, 129, 0.45);
      box-shadow: 0 0 16px -2px rgba(16, 185, 129, 0.2);
    }

    .user-avatar-glow {
      border-radius: 50%;
      width: 34px;
      min-width: 34px;
      height: 34px;
      background-position: center center;
      background-size: cover;
      border: 2px solid rgba(16, 185, 129, 0.5);
      box-shadow: 0 0 10px rgba(16, 185, 129, 0.25);
    }

    .content-box {
      flex: 1;

      .message-box {
        width: 100%;

        .comment-input {
          .v-input__control .v-input__slot {
            background: rgba(9, 14, 26, 0.65) !important;
            border-radius: 8px !important;
            border: 1px solid rgba(255, 255, 255, 0.08) !important;
            transition: all 0.2s ease;

            input {
              color: rgba(255, 255, 255, 0.95);
              font-size: 13px;
              &::placeholder {
                color: rgba(255, 255, 255, 0.4) !important;
              }
            }
          }

          &.v-input--is-focused .v-input__slot {
            border-color: #10b981 !important;
          }
        }

        .comment-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          margin-top: 10px;

          .btn-cancel {
            color: rgba(255, 255, 255, 0.65) !important;
            border-radius: 6px;
            font-size: 12px;
            &:hover {
              background: rgba(255, 255, 255, 0.08);
              color: #ffffff !important;
            }
          }

          .btn-submit {
            background: linear-gradient(135deg, #10b981 0%, #0d9488 100%) !important;
            color: #ffffff !important;
            font-weight: 600;
            font-size: 12px;
            border-radius: 6px;
            box-shadow: 0 3px 10px -2px rgba(16, 185, 129, 0.45);
            transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);

            &:hover:not(:disabled) {
              transform: translateY(-1px);
              box-shadow: 0 6px 16px -2px rgba(16, 185, 129, 0.6);
            }

            &:disabled {
              opacity: 0.45;
              cursor: not-allowed;
            }
          }
        }
      }
    }
  }

  .comment-list {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .comment-item-card {
      display: flex;
      gap: 12px;
      padding: 12px 14px;
      border-radius: 10px;
      background: rgba(255, 255, 255, 0.03);
      border: 1px solid rgba(255, 255, 255, 0.05);
      transition: all 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.06);
        border-color: rgba(255, 255, 255, 0.1);
      }

      .avatar-sm {
        border-radius: 50%;
        width: 30px;
        min-width: 30px;
        height: 30px;
        background-position: center center;
        background-size: cover;
        border: 1px solid rgba(255, 255, 255, 0.2);
      }

      .comment-body {
        flex: 1;

        .comment-meta {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 4px;

          .author-name {
            font-size: 13px;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.88);
          }

          .post-date {
            font-size: 11px;
            color: rgba(255, 255, 255, 0.4);
          }
        }

        .comment-text {
          font-size: 13px;
          line-height: 1.5;
          color: rgba(255, 255, 255, 0.72);
          margin: 0;
          word-break: break-all;
        }
      }
    }
  }

  .empty-comment {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px 0;
    gap: 8px;

    .empty-text {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.35);
      margin: 0;
    }
  }
}
</style>